module.exports = __webpack_public_path__ + "img/infinity-kingdom.af43374.jpg";